export const CODE_MSG = {
  517: 'PROMO_JUST_RAN_OUT_OF_STOCK',
  311: 'min_selection_error',
  312: 'max_selection_error',
  314: 'Product id is not sellable!',
  302: 'not_in_live',
  301: 'product_changed',
  303: 'out_of_product_stock',
  307: 'out_of_modifier_option_stock',
  305: 'modifier_changed',
  309: 'modifier_illegal',
  507: 'InvalidPhone',
  515: 'scheduled_order_time_not_available',
  600: 'productStoreId_is_null',
  514: 'tableNumber_is_illegal',
  803: 'voucher_invalid',
}

export const GROUP_TYPE = {
  PACKAGE: 'PACKAGE',
  PACKAGE_BASE: 'PACKAGE_BASE',
  PACKAGE_OPTION: 'PACKAGE_OPTION',
  SINGLE: 'SINGLE',
  MODIFIER: 'MODIFIER',
}

export const emailReg = '^[a-zA-Z0-9]+([._\\-]*[a-zA-Z0-9])*@([a-zA-Z0-9]+[-a-zA-Z0-9]*[a-zA-Z0-9]+.){1,63}[a-zA-Z0-9]+$';
export const ovoPhoneReg = '^\\+62.{8}';


export const storeBlackList = [
  'admin',
  'api',
  'multiflex',
  'seller',
  'accounting',
  'ap',
  'ar',
  'ofbizsetup',
  'ordermgr-js',
  'content',
  'contentimages',
  'humanres',
  'manufacturing',
  'marketing',
  'sfa',
  'ordermgr',
  'partymgr',
  'facility',
  'catalog',
  'workeffort',
  'iCalendar',
  'ical',
  'datamodel',
  'images',
  'webapp',
  'webtools',
  'widget',
  'base',
  'entity',
  'security',
  'datafile',
  'minilang',
  'testtools',
  'entityext',
]


export const defaultCover = 'https://static.bakmigm.co.id/menu/buyer-new-cover-0113.png';
// export const defaultLogo = 'https://static.bakmigm.co.id/menu/buyer-new-logo.png';
export const defaultLogo = 'https://static.bakmigm.co.id/menu-buyer/order/mybakmigm-default-logo.svg';
// export const holderLogo = 'https://static.bakmigm.co.id/menu/buyer-holder-logo.jpeg';
export const holderLogo = 'https://static.bakmigm.co.id/menu-buyer/order/mybakmigm-default-logo.svg';

/**
 * event bus message
 */
// 推荐商品添加成功
export const ADD_SUCCESS_RECOMMEND = 'add-success-recommend';

// 推荐位产品失效通知
export const RECOMMEND_PRODUCT_INVALID = 'recommend-product-invalid';

// 商品详情，商品不可用异常通知
export const PRODUCT_DETAIL_INVALID = 'product-detail-invlaid';

// checkout option接口完成通知
export const CHECKOUT_OPTION_LOADED = 'checkout-option-loaded';


// Full Dine In 模式下，换桌成功后，需要弹窗带的页面
export const TABLE_CHANGE_SUCCESS_POPUP_PAGES = [
  'products-list',
  'products-detail',
  'product-detail',
  'CartConfirm',
  'FullCheckout',
  'OnGoing',
  'cart'
]

// 机器人webhook
export const WEB_HOOK = 'https://open.larksuite.com/open-apis/bot/v2/hook/c51e1a88-df5b-4f6a-a2e8-d7f36847001f';

// note最大长度
export const MAX_NOTE_LENGTH = 20;
